// extracted by mini-css-extract-plugin
module.exports = {"list":"ProductTypeCardList_list__xeXE1"};